<template>
  <div
    class="rectangle"
    :class="{ 'disable-rectangle': modalActive }"
    :id="data.id"
    @mouseover="mousOver"
    @mouseleave="mouseOut"
    @click="showElement(data)"
    :style="customStyle()"
  ></div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
export default {
  name: 'tr-rectangle',
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  methods: {
    /**
     * uruchomienie poprzez nacisniecie ramki
     * @method showElement
     * @param  {Object}    data obiekt z pliku konfiguracyjnego rectangle
     */
    showElement(data) {
      let button;
      let index;
      if (data.activeIndex) {
        let id = parseInt(data.activeIndex);
        this.$router.push({
          name: 'page-view',
          params: { id: `${id}`, multibookType: `${this.$store.getters.multibookType}` },
        });
        // index = data.activeIndex;
        // let findPage = _.find(this.$store.getters[`${this.correctModuleName}/getPages`], (doublePage) => {
        //   if (
        //     (doublePage.left && doublePage.left.id === index) ||
        //     (doublePage.right && doublePage.right.id === index)
        //   ) {
        //     return true;
        //   }
        // });
        // if (findPage && findPage.id !== this.$store.getters[`${this.correctModuleName}/getActualPage`].id) {
        //   this.$store.commit(`${this.correctModuleName}/CHANGE_ACTUAL_PAGE`, findPage.id);
        //   // this.jumpTo( findPage.left.id || findPage.right.id || 0 );
        //   this.$parent.jumpTo(findPage.id + 1);
        // } else {
        //   console.log('Not a number');
        // }
      } else {
        let query = '#' + data.linked[0];
        let elem = document.querySelector(query);
        elem.click();
      }
    },
    imagePath(iconId, off = true) {
      let images = require.context('../../../assets/icons/', false, /\.png$/);
      return images('./' + iconId + '' + (off ? '-OFF' : '-ON') + '.png');
    },
    onClickButton(path) {},
    iconON(id) {
      let query = '#' + id + ' ' + '.icon-on';
      let element = document.querySelector(query);
      element.classList.add('fakeHover');
    },
    iconOFF(id) {
      let query = '#' + id + ' ' + '.icon-on';
      let element = document.querySelector(query);
      element.classList.remove('fakeHover');
    },
    mousOver() {
      let list = _.cloneDeep(this.data.linked);
      list.forEach(this.iconON);
    },
    mouseOut() {
      let list = _.cloneDeep(this.data.linked);
      list.forEach(this.iconOFF);
    },
    rectangleProcess(
      rect,
      boxSize = {
        // width: 1920,
        // height: 2720
        width: parseInt(this.realWidth),
        height: parseInt(this.realHeight),
      }
    ) {
      let newRect = _.cloneDeep(rect);
      let color = rect.color || '#ffc800';
      let x = newRect.x;
      let y = newRect.y;
      let width = newRect.width;
      let height = newRect.height;
      if (!rect.noBounds) {
        x = newRect.x += this.rectangleOffset.x;
        y = newRect.y += this.rectangleOffset.y;
        width = newRect.width += this.rectangleOffset.width;
        height = newRect.height += this.rectangleOffset.height;
        newRect.width = newRect.width > boxSize.width ? boxSize.width : newRect.width;
        newRect.height = newRect.height > boxSize.height ? boxSize.height : newRect.height;
        newRect.x = newRect.x < 0 ? 0 : newRect.x;
        newRect.x = newRect.x > boxSize.width ? boxSize.width - newRect.width : newRect.x;
        newRect.y = newRect.y < 0 ? 0 : newRect.y;
        newRect.y = newRect.y > boxSize.height ? boxSize.height - newRect.height : newRect.y;
        x = newRect.x > boxSize.width ? boxSize.width : newRect.x;
        y = newRect.y > boxSize.height ? boxSize.height : newRect.y;
        width = newRect.width > boxSize.width ? boxSize.width : newRect.width;
        height = newRect.height > boxSize.height ? boxSize.height : newRect.height;
      }
      x = (x * 100) / boxSize.width;
      y = (y * 100) / boxSize.height;
      width = (width * 100) / boxSize.width;
      height = (height * 100) / boxSize.height;
      return {
        x,
        y,
        width,
        height,
        color,
      };
    },
    customStyle() {
      return ` top:${this.rectangleObject.y}%;
    left:${this.rectangleObject.x}%;
    width:${this.rectangleObject.width}%;
    height:${this.rectangleObject.height}%;
    border-color:${this.rectangleObject.color};`;
    },
  },
  computed: {
    correctModuleName() {
      let name = this.$store.getters.multibookType;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
    rectangleOffset() {
      return this.$store.getters.rectangleOffset;
    },
    realWidth: function() {
      return this.$store.getters.realWidth;
    },
    realHeight: function() {
      return this.$store.getters.realHeight;
    },
    rectangleObject: function() {
      return this.rectangleProcess(this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.rectangle {
  position: absolute;
  z-index: 180;
  transition: box-shadow 0.3s ease-out;
  cursor: pointer;
  pointer-events: auto;
}
.rectangle:hover {
  position: absolute;
  z-index: 180;
  // box-shadow: inset 0 0 40px $borderColor;
  // transition: box-shadow 0.3s ease-out;
  border: $borderWidth solid $borderColor;
  background-color: $rectangleHoverBackgroundColor;
}
.disable-rectangle {
  display: none;
}
</style>
